import React, { useEffect, useState, useRef } from "react";
import "./AdaptorComponent.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import gift from "../../images/gift.svg";
import co from "../../images/adaptor-image.png";
import Allbook from "../Allbook/Allbook";
import com from "../../images/compass-icon.svg";
import gg from "../../images/gift-green.svg";
import sr from "../../images/search-black.svg";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import axios from "axios";

function AdaptorComponent() {

  const [initialLoaded, setInitialLoaded] = useState(false);

  const [loading, setLoading] = useState(false);

  const [ebookLoading, setEbookLoading] = useState(true);

  const [page, setPage] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const [search, setSearch] = useState("");

  const [categoryId, setCategoryId] = useState("");

  const [error, setError] = useState("");

  const [activeCategory, setActiveCategory] = useState("all");

  const [suggestions, setSuggestions] = useState([]);

  const [showSuggestions, setShowSuggestions] = useState(false);

  const debounceRef = useRef(null);

  const handleCategoryClick = (categoryId) => {

    setActiveCategory(categoryId);

    setCategoryId(categoryId === "all" ? "" : categoryId);

    setCurrentPage(1);  
  };

  useEffect(() => {

    fetchPage(currentPage);

  }, [currentPage, categoryId]);

  const fetchPage = async (pageNumber = 1, searchValue = search) => {

    try {

      if (!initialLoaded) {

        setLoading(true);

      } else {

        setEbookLoading(true);
      }

      const response = await axios.get(`${END_URL}/ebook-store`, {

          params: {

              page: pageNumber,

              category_id: categoryId,

              search: searchValue
          }
      });

      if (response.data.success) {

        setPage(response.data.data);

        setInitialLoaded(true);

      } else {

        setError("Page not found");
      }

    } catch (error) {

      console.log(error);

      setError("Failed to load page");

    } finally {

      
      setLoading(false);

      setEbookLoading(false);
    }
  };

    useEffect(() => {

        const handleClickOutside = (event) => {

            if (!event.target.closest(".adapter-search-field")) {

                setShowSuggestions(false);

            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {

            document.removeEventListener("click", handleClickOutside);

        };

    }, []);


  if (loading) {

    return (
      <div className="loadingDiv" >

        <img src={ff} alt="Loading..." />

      </div>
    );
  }


  return (
    <div className="adapter-container">
      <div className="container">

        <div className="row">

          <div className="adaptor-outer-box">
            <div className="adaptor-box-one">
              <div className="adaptor-icon">
                <span>
                  <img src={`${IMG_URL}/d0/${page?.ebook_button_icon}`} alt="" />
                </span>

                <p>{page?.ebook_badge_title}</p>

              </div>

              <div className="adaptor-text">

                <h5>{page?.ebook_main_title}</h5>

                <div dangerouslySetInnerHTML={{ __html: page?.ebook_description || "" }} />

              </div>

              <div className="adaptor-btn-div">

                <a href={`ebook/${page?.ebook_buttom_text_link}`} class="new-commom-btn adapter-btn">

                  <span>{page?.ebook_button_label}</span>

                  <span class="righ-arr">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>

                <p>{page?.ebook_bottom_text}</p>

              </div>

            </div>

            <div className="adaptor-box-two">

              <div className="adaptor-imgDiv">

                <img src={`${IMG_URL}/d0/${page?.ebook_banner_image}`} alt="" />

              </div>

              <ul>
                <li>
                  <span>

                    <img src={`${IMG_URL}/d0/${page?.feature_icon_1}`} alt="" />

                  </span>
                  <div>
                    <h6>{page?.feature_title_1}</h6>
                    <p>{page?.feature_description_1}</p>
                  </div>
                </li>

                <li>
                  <span>
                    <img src={`${IMG_URL}/d0/${page?.feature_icon_2}`} alt="" />
                  </span>
                  <div>
                    <h6>{page?.feature_title_2}</h6>
                    <p>{page?.feature_description_2}</p>
                  </div>
                </li>

                <li>
                  <span>
                    <img src={`${IMG_URL}/d0/${page?.feature_icon_3}`} alt="" />
                  </span>
                  <div>
                    <h6>{page?.feature_title_3}</h6>
                    <p>
                      {page?.feature_description_3}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

        </div>

        <div className="row">

          <div className="adapter-seach">

            <div className="adapter-input">

             <div className="adapter-search-field">

                <input
                    type="text"
                    value={search}
                    placeholder="Search books by title, archetype, or keyword..."

                    onChange={async (e) => {

                        const value = e.target.value;

                        setSearch(value);

                        setCurrentPage(1);

                        if (!value.trim()) {

                            setSuggestions([]);

                            setShowSuggestions(false);

                            fetchPage(1, "");

                            return;
                        }

                        try {

                            clearTimeout(debounceRef.current);

                            debounceRef.current = setTimeout(async () => {

                                const response = await axios.get(
                                    `${END_URL}/ebook-suggestions`,
                                    {
                                        params: {
                                            search: value
                                        }
                                    }
                                );

                                if (response.data.success) {

                                    setSuggestions(response.data.data || []);

                                    setShowSuggestions(true);

                                }

                            }, 300);

                        } catch (error) {

                            // console.log(error);

                        }

                    }}

                    onKeyDown={(e) => {

                        if (e.key === "Enter") {

                            fetchPage(1, search);

                            setShowSuggestions(false);

                        }

                    }}

                    onFocus={() => {

                        if (suggestions.length > 0) {

                            setShowSuggestions(true);

                        }

                    }}
                />

                <button
                    type="button"

                    onClick={() => {

                        fetchPage(1, search);

                        setShowSuggestions(false);

                    }}
                >

                    <img src={sr} alt="Search" />

                </button>

                {showSuggestions && suggestions.length > 0 && (

                    <div className="adapter-search-suggestions">

                        {suggestions.map((book) => (

                            <div
                                key={book.id}

                                className="adapter-search-item"

                                onClick={() => {

                                    setSearch(book.title);

                                    setShowSuggestions(false);

                                    setSuggestions([]);

                                    fetchPage(1, book.title);

                                }}
                            >

                                <div className="adapter-search-image">

                                    <img
                                        src={`${IMG_URL}/d0/${book.book_cover}`}
                                        alt={book.title}
                                    />

                                </div>

                                <div className="adapter-search-content">

                                    <h6>{book.title}</h6>

                                    {book.short_description && (
                                        <p>

                                            {book.short_description
                                                .replace(/<[^>]*>/g, "")
                                                .slice(0, 80)}

                                            {book.short_description.length > 80 ? "..." : ""}

                                        </p>
                                    )}

                                </div>

                            </div>

                        ))}

                    </div>

                )}

            </div>
            </div>

            <div className="adapter-tabs">

              <ul>

                <li className={activeCategory === "all" ? "active": ""} onClick={() => handleCategoryClick("all")} >{page?.all_ebook_label}</li>

                {page?.categories?.map((category) => (

                  <li key={category.id} className={activeCategory === category.id? "active": ""} onClick={() => handleCategoryClick(category.id)} > 

                    {category.name}

                  </li>
                ))}

                <li className={activeCategory === "free" ? "active" : "" }  onClick={() => handleCategoryClick("free")} >

                  <span>
                    <img src={gg} alt="" />
                  </span>{" "}
                  {page?.all_ebook_free_books_label}

                </li>

              </ul>

            </div>

          </div>

        </div>

        <div className="row">

          <div className="adapter-book-call">


              {ebookLoading ? (

                  <div className="ebook-loading text-center py-5">

                      <img src={ff}  alt="Loading..."  style={{  width: "70px"  }}/>
                    
                  </div>

                ) : (

                  <>

                  <Allbook categoryId={activeCategory} ebook_list_content={page?.ebook_list_content} ebook_data={page?.ebooks} ebook_free_books_label={page?.ebook_free_books_label} />

                 {page?.pagination?.last_page > 1 && (

                      <div className="col-12 col-sm-12 col-md-12 ebook-pagination">

                        <div className="pagination">

                          <button

                            disabled={currentPage <= 1 || ebookLoading}

                            onClick={() => {

                              if (currentPage > 1) {

                                setCurrentPage((prev) => prev - 1);
                              }
                            }}>

                            Previous

                          </button>

                          {[...Array(page?.pagination?.last_page)].map((_, index) => {

                            const pageNumber = index + 1;

                            return (

                              <button
                                key={pageNumber}

                                disabled={ebookLoading}

                                className={
                                  pageNumber === currentPage
                                    ? "active"
                                    : ""
                                }

                                onClick={() => {

                                  if (pageNumber !== currentPage) {

                                    setCurrentPage(pageNumber);
                                  }
                                }}>

                                {pageNumber}

                              </button>
                            );
                          })}

                          <button

                            disabled={
                              currentPage >= page?.pagination?.last_page ||
                              ebookLoading
                            }

                            onClick={() => {

                              if (currentPage < page?.pagination?.last_page) {

                                setCurrentPage((prev) => prev + 1);
                              }
                            }}>

                            Next

                          </button>

                        </div>

                      </div>

                    )}

                </>

              )}
              
          </div>

        </div>

        <div className="row">
          <div className="adapter-cta-div">
            <div className="adapt-cta-img">
              <div>
                <span>
                  <img src={com} alt="" />
                </span>
              </div>
            </div>

            <div className="adapt-cta-text" dangerouslySetInnerHTML={{__html:page?.ebook_footer_content}} />
              
            <div className="adapt-cta-btn">

                <a href={page?.ebook_footer_buttom_link} class="new-commom-btn adapter-btn">

                  <span>{page?.ebook_footer_buttom_text}</span>

                  <span class="righ-arr">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdaptorComponent;
